// extracted by css-extract-rspack-plugin
export default {"body":"AehLf","column":"yxabU","preview":"rv47v","header":"nEpXO"};